import { ArrowBack, Close } from "@mui/icons-material";
import React from "react";

export const UiBackBreadCrumb = (props) => {
  return (
    <>
      <div className="df-breadcrumb-back">
        {!props?.disableBackButton && (
          <div
            className="df-breadcrumb-back__back"
            onClick={props?.backOnClick}
          >
            <ArrowBack />
            {props?.backText}
          </div>
        )}
        {props?.titleText && (
          <div className="df-breadcrumb-back__title df-ml-min5">
            {props?.titleText}
          </div>
        )}
        {!props?.disableCloseButton && (
          <div
            className="df-breadcrumb-back__close"
            onClick={props?.closeOnClick}
          >
            <Close />
          </div>
        )}
      </div>
    </>
  );
};
